const DELIVERY_ORDER_BATCH_STATUS = {
	created: 'CREATED',
	assignedToDelivery: 'ASSIGNED_TO_DELIVERY',
	packed: 'PACKED',
	inTransit: 'IN_TRANSIT',
	delivered: 'DELIVERED',
};

export default DELIVERY_ORDER_BATCH_STATUS;